import { defineComponent as _defineComponent } from 'vue'
import { MutationLoginArgs, Mutation } from "@/CodegenTypes";
import { apolloClient, mutations } from "@/apollo";
import { errorMutationNotification } from "@/utils";
import { computed, reactive } from "vue";
import { useRouter } from "vue-router/composables";
import { useRootStore } from "@/store/pinia";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const state = reactive({
  failedSubmit: false,
  userId: "",
  password: "",
  loading: {
    signIn: false,
  },
});
const siteName = computed(() => process.env.VUE_APP_THEME_SITE_NAME || "Gen Trader PRO")

const router = useRouter();

const { $t } = useTranslation();


const backgroundImgFilePath = computed(() => {
  const envBg = process.env.VUE_APP_THEME_BACKGROUND;
  return envBg
    ? require(`@/assets/images/${envBg}`)
    : require(`@/assets/images/gen-trader.webp`);

})

const formInvalid = computed(() =>
  !state.userId.trim() || !state.password.trim()
)

function focusNext(elem: HTMLFormElement) {
  const currentIndex = Array.from(elem.form.elements).indexOf(elem);
  elem.form.elements.item(
    currentIndex < elem.form.elements.length - 1 ?
      currentIndex + 1 :
      0
  ).focus();
}
const store = useRootStore()


async function login() {
  state.loading.signIn = true;
  // try {
  //   if (!this.userId.trim() || !this.password.trim()) {
  //     return;
  //   }
  //   if (this.userId.trim().toLowerCase() !== 'demo') {
  //     throw new Error('Invalid userId or Password');
  //   }
  //   if (this.password !== 'demo') {
  //     throw new Error('Invalid userId or Password');
  //   }
  //   // await new Promise((resolve) => { setTimeout(() => resolve(),1000) })
  //   this.$router.push({ name: 'tnc' });
  // } catch (err) {
  //   errorMutationNotification(err);
  // } finally {
  //   this.loading.signIn = false;
  // }

  try {
    state.loading.signIn = true;
    const result = await apolloClient.mutate<
      { login: Mutation["login"] },
      MutationLoginArgs
    >({
      mutation: mutations.login,
      variables: {
        userId: state.userId,
        password: state.password,
      },
    });
    const tokensResponse = result.data?.login;
    if (tokensResponse) {
      const refreshToken = tokensResponse.refreshToken;
      const accessToken = tokensResponse.accessToken;
      // store.commit("setAccessToken", accessToken);
      // store.commit("setRefreshToken", refreshToken);
      store.accessToken = accessToken;
      store.refreshToken = refreshToken;
      router.push({ name: "tnc" });
    }
  } catch (err: any) {
    state.failedSubmit = true;
    errorMutationNotification(err)
  }
  state.loading.signIn = false;
}

return { __sfc: true,state, siteName, router, $t, backgroundImgFilePath, formInvalid, focusNext, store, login }
}

})